import StoreBadges from '../common/store_badges';
import Viewer from 'viewerjs';

document.addEventListener('DOMContentLoaded', () => {
  const indexDiv = document.getElementById('leaflets_index') as HTMLElement;

  if (indexDiv == null) {
    return;
  }

  const searchForm = indexDiv.querySelector('#leaflets_search_form') as HTMLElement;
  const searchStatusSelect = searchForm.querySelector('#status') as HTMLSelectElement;
  const checkBoxTds = indexDiv.querySelectorAll('td.check-box');
  const checkBoxThs = indexDiv.querySelectorAll('th.check-box');

  checkBoxTds.forEach(checkBoxTd => {
    const checkbox = checkBoxTd.querySelector('input') as HTMLInputElement;
    checkBoxTd.addEventListener('click', (e) => {
      if ((e.target as HTMLElement).tagName != 'INPUT') {
        checkbox.click();
      }
    });
  });

  checkBoxThs.forEach(checkBoxTh => {
    const checkbox = checkBoxTh.querySelector('input') as HTMLInputElement;
    checkBoxTh.addEventListener('click', (e) => {
      if ((e.target as HTMLElement).tagName != 'INPUT') {
        checkbox.click();
      }
    });
  });

  // ツールバーを表示/非表示する
  const toggleBulkToolbar = () => {
    const toolbar = document.getElementById('leaflets_bulk_toolbar');
    const publishAllButton = document.querySelector('.publish-all-button') as HTMLElement;
    const publishAllGbpButton = document.querySelector('.publish-all-gbp-button') as HTMLElement;
    const checkedBoxes = document.querySelectorAll('.leaflet-id-check-box:checked');
    const checkedBoxesWithDraft = document.querySelectorAll('.leaflet-id-check-box.draft:checked');
    if (toolbar == null) {
      return;
    }
    // ツールバー自体の表示/非表示
    if (checkedBoxes.length == 0) {
      toolbar.style.display = 'none';
    } else {
      toolbar.style.display = 'block';
    }
    // 公開ボタンの表示/非表示 (下書きチラシがあるかどうか)
    if (checkedBoxesWithDraft.length == 0) {
      publishAllButton.style.display = 'none';
      if(publishAllGbpButton) {
        publishAllGbpButton.style.display = 'none';
      }
    } else {
      publishAllButton.style.display = 'inline-block';
      if(publishAllGbpButton) {
        publishAllGbpButton.style.display = 'inline-block';
      }
    }
  };

  // チェックボックスがクリックされるごとに実行
  const checkboxes = document.querySelectorAll('.leaflet-id-check-box');
  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', () => {
      toggleBulkToolbar();
    });
  });

  const allCheckBox = document.getElementById('all_check_for_leaflet_ids');
  if (allCheckBox != null) {
    (allCheckBox as HTMLElement).addEventListener('change', () => {
      if ((allCheckBox as HTMLInputElement).checked) {
        checkboxes.forEach(checkbox => {
          (checkbox as HTMLInputElement).checked = true;
        });
      } else {
        checkboxes.forEach(checkbox => {
          (checkbox as HTMLInputElement).checked = false;
        });
      }
      toggleBulkToolbar();
    });
  }

  const onClickActionsForAllButtons = () => {
    const destroyAllButton = document.querySelector('.destroy-all-button')  as HTMLElement;
    const publishAllButton = document.querySelector('.publish-all-button') as HTMLElement;
    const publishAllGbpButton = document.querySelector('.publish-all-gbp-button') as HTMLElement;
    onClickActionsForAllButton(destroyAllButton, '本当に削除しますか？');
    onClickActionsForAllButton(publishAllButton, '本当に公開しますか？');
    if (publishAllGbpButton) {
      onClickActionsForAllButton(publishAllGbpButton, 'GBPに連携します。よろしいですか？');
    }
  }

  const onClickActionsForAllButton = (button: HTMLElement, confirmMessage: string) => {
    const form = document.getElementById('leaflet_action_for_all');
    button.addEventListener('click', () => {
      const path = button.dataset.path as string;
      (form as HTMLElement).setAttribute('action', path);
      if (confirm(confirmMessage)) {
        (form as HTMLFormElement).submit();
      }
    });
  }

  const viewerInit = () => {
    const leafletThumbnails = document.querySelectorAll('.leaflet-thumbnail-image');

    leafletThumbnails.forEach(leafletThumbnail => {
      const image = (leafletThumbnail as HTMLElement).querySelector('img') as HTMLElement;
      if (image) {
        const viewer = new Viewer(image, {
          title: false,
          toolbar: {
            zoomIn: true,
            zoomOut: true,
            oneToOne: false,
            reset: false,
            prev: false,
            next: false,
            play: {
              show: false,
            },
            rotateLeft: false,
            rotateRight: false,
            flipHorizontal: false,
            flipVertical: false,
          },
        });
        leafletThumbnail.addEventListener('click', () => {
          viewer.show();
        });
      }
    });
  };

  const toggleTitleSearchInput = () => {
    const searchTitleInput = searchForm.querySelector('#title') as HTMLInputElement;
    if (searchStatusSelect.value == '') {
      searchTitleInput.disabled = true;
    } else {
      searchTitleInput.disabled = false;
    }
  };
  searchStatusSelect.addEventListener('change', () => {
    toggleTitleSearchInput();
  });

  const initialize = () => {
    toggleBulkToolbar();
    toggleTitleSearchInput();
    const storeBadgesClient = new StoreBadges();
    storeBadgesClient.initialize(indexDiv);
    onClickActionsForAllButtons();
    viewerInit();
  }

  // 初期実行
  initialize();
});
